// LICENSE : MIT
"use strict";

module.exports = {
    "CHANGE_URL": "CHANGE_URL"
};


/*****************
 ** WEBPACK FOOTER
 ** ./lib/router/RouterConst.js
 ** module id = 6
 ** module chunks = 0
 **/